(function(global){
"use strict";

var Engine = {};
Engine.version = "V2_BRAND_SCENES_COFFEE";
Engine.width = 1080;
Engine.height = 1920;
Engine.fps = 30;

function B(){
  return global.DRIVE_IQ_BRAND || {
    colors:{background:"#07131A",backgroundDeep:"#041014",panel:"#0D1F29",text:"#F4FBFF",mutedText:"#9BB2BF",primary:"#6CFFB3",secondary:"#60D9FF",scrim:"rgba(0,0,0,.62)"},
    typography:{family:'-apple-system,BlinkMacSystemFont,"SF Pro Display","Helvetica Neue",Arial,sans-serif',heroWeight:900,titleWeight:850,bodyWeight:600},
    geometry:{cardRadius:24,safePadding:64},
    map:{background:"#0A171D",roadPrimary:"#263A42",roadSecondary:"#1B2B32",routeWidth:12,routeGlowWidth:24,routeGlowAlpha:.20,pinFill:"#6CFFB3",pinStroke:"#07131A",poiFill:"#60D9FF",selectedPoiFill:"#6CFFB3"},
    motion:{lineDrawMs:1200,pinDropMs:480,poiPopMs:280,cardInMs:420,pulseMs:1500},
    cta:{primary:"Try Drive IQ",secondary:"Available on the App Store",endCardHeadline:"Navigation should do more than tell you where to turn.",endCardSubhead:"Drive smarter with Drive IQ."},
    contentRules:{preferHumanOpening:true,useAppScreensAsProof:true,illustrativeLabel:"Concept visualization"}
  };
}

function sleep(ms){ return new Promise(function(r){ setTimeout(r,ms); }); }
function clamp(v,a,b){ return Math.max(a,Math.min(b,v)); }

function bestMime(){
  if(!global.MediaRecorder) return "";
  var types=["video/mp4;codecs=h264,aac","video/mp4;codecs=avc1","video/webm;codecs=vp9","video/webm;codecs=vp8","video/webm"];
  for(var i=0;i<types.length;i++){
    try{ if(MediaRecorder.isTypeSupported(types[i])) return types[i]; }catch(e){}
  }
  return "";
}

function coverRect(sw,sh,dw,dh){
  var s=Math.max(dw/sw,dh/sh), w=sw*s, h=sh*s;
  return {x:(dw-w)/2,y:(dh-h)/2,w:w,h:h};
}

function drawWrapped(ctx,text,x,y,maxWidth,lineHeight,maxLines,align){
  text=String(text||"");
  var words=text.split(/\s+/), line="", lines=[];
  for(var i=0;i<words.length;i++){
    var test=line ? line+" "+words[i] : words[i];
    if(ctx.measureText(test).width > maxWidth && line){
      lines.push(line); line=words[i];
      if(lines.length>=maxLines) break;
    }else line=test;
  }
  if(lines.length<maxLines && line) lines.push(line);
  ctx.textAlign=align||"left";
  for(var j=0;j<lines.length;j++){ ctx.fillText(lines[j],x,y+j*lineHeight); }
}

function roundedRect(ctx,x,y,w,h,r){
  r=Math.min(r,w/2,h/2);
  ctx.beginPath();
  ctx.moveTo(x+r,y);ctx.lineTo(x+w-r,y);ctx.quadraticCurveTo(x+w,y,x+w,y+r);
  ctx.lineTo(x+w,y+h-r);ctx.quadraticCurveTo(x+w,y+h,x+w-r,y+h);
  ctx.lineTo(x+r,y+h);ctx.quadraticCurveTo(x,y+h,x,y+h-r);
  ctx.lineTo(x,y+r);ctx.quadraticCurveTo(x,y,x+r,y);ctx.closePath();
}

function drawBrand(ctx){
  var b=B();
  ctx.save();
  ctx.fillStyle="rgba(0,0,0,.40)";
  ctx.fillRect(0,0,Engine.width,124);
  ctx.font="800 46px "+b.typography.family;
  ctx.fillStyle=b.colors.text;
  ctx.textAlign="left";
  ctx.fillText("Drive IQ",64,80);
  ctx.font="800 22px "+b.typography.family;
  ctx.fillStyle=b.colors.primary;
  ctx.textAlign="right";
  ctx.fillText("MOMENTUM IQ",1016,76);
  ctx.restore();
}

function drawTruthLabel(ctx){
  var b=B();
  if(!b.contentRules || !b.contentRules.illustrativeLabel) return;
  ctx.save();
  ctx.font="700 18px "+b.typography.family;
  ctx.fillStyle="rgba(255,255,255,.55)";
  ctx.textAlign="right";
  ctx.fillText(b.contentRules.illustrativeLabel,1016,116);
  ctx.restore();
}

function drawOverlay(ctx,scene,progress){
  var b=B();
  ctx.save();
  var grad=ctx.createLinearGradient(0,980,0,Engine.height);
  grad.addColorStop(0,"rgba(0,0,0,0)");
  grad.addColorStop(.38,"rgba(0,0,0,.28)");
  grad.addColorStop(1,"rgba(0,0,0,.88)");
  ctx.fillStyle=grad;ctx.fillRect(0,900,Engine.width,1020);

  if(scene.overlay){
    ctx.font="900 72px "+b.typography.family;
    ctx.fillStyle=b.colors.text;
    ctx.textBaseline="top";
    drawWrapped(ctx,scene.overlay,64,1230,950,82,4,"left");
  }
  if(scene.subtext){
    ctx.font="650 36px "+b.typography.family;
    ctx.fillStyle=b.colors.mutedText;
    drawWrapped(ctx,scene.subtext,64,1600,930,48,3,"left");
  }
  ctx.fillStyle="rgba(255,255,255,.16)";
  ctx.fillRect(64,1840,952,10);
  ctx.fillStyle=b.colors.primary;
  ctx.fillRect(64,1840,952*clamp(progress,0,1),10);
  ctx.restore();
}

function drawEndCard(ctx,project){
  var b=B();
  ctx.fillStyle=b.colors.backgroundDeep || b.colors.background;
  ctx.fillRect(0,0,Engine.width,Engine.height);

  var g=ctx.createRadialGradient(540,620,80,540,620,680);
  g.addColorStop(0,"rgba(96,217,255,.25)");
  g.addColorStop(1,"rgba(7,19,26,0)");
  ctx.fillStyle=g;ctx.fillRect(0,0,Engine.width,Engine.height);

  ctx.textAlign="center";
  ctx.fillStyle=b.colors.primary;
  ctx.font="800 32px "+b.typography.family;
  ctx.fillText("DRIVE IQ",540,560);

  ctx.fillStyle=b.colors.text;
  ctx.font="900 82px "+b.typography.family;
  drawWrapped(ctx,project.ctaHeadline || b.cta.endCardHeadline || "Try Drive IQ",540,690,900,94,4,"center");

  ctx.font="650 36px "+b.typography.family;
  ctx.fillStyle=b.colors.mutedText;
  ctx.fillText(project.ctaSub || b.cta.endCardSubhead || "Drive smarter with Drive IQ.",540,1130);

  roundedRect(ctx,300,1250,480,104,22);
  ctx.fillStyle=b.colors.text;ctx.fill();
  ctx.fillStyle=b.colors.background;
  ctx.font="900 38px "+b.typography.family;
  ctx.fillText(b.cta.primary || "Try Drive IQ",540,1318);

  ctx.fillStyle=b.colors.text;
  ctx.font="800 30px "+b.typography.family;
  ctx.fillText(b.cta.secondary || "Available on the App Store",540,1445);
  ctx.textAlign="left";
}

function drawStylizedMapBase(ctx){
  var b=B();
  ctx.fillStyle=b.map.background;ctx.fillRect(0,0,Engine.width,Engine.height);

  ctx.save();
  ctx.strokeStyle=b.map.roadSecondary;ctx.lineCap="round";
  ctx.lineWidth=44;
  ctx.beginPath();ctx.moveTo(-80,1580);ctx.bezierCurveTo(260,1410,320,1010,630,910);ctx.bezierCurveTo(800,850,940,910,1160,690);ctx.stroke();

  ctx.lineWidth=32;
  ctx.beginPath();ctx.moveTo(250,1970);ctx.bezierCurveTo(360,1510,500,1340,720,1320);ctx.bezierCurveTo(900,1310,980,1210,1160,1120);ctx.stroke();

  ctx.lineWidth=26;
  ctx.beginPath();ctx.moveTo(180,-100);ctx.bezierCurveTo(300,300,390,660,260,1200);ctx.bezierCurveTo(215,1410,170,1640,190,2010);ctx.stroke();

  ctx.strokeStyle=b.map.roadPrimary;ctx.lineWidth=52;
  ctx.beginPath();ctx.moveTo(-100,1650);ctx.bezierCurveTo(200,1480,340,1180,590,1040);ctx.bezierCurveTo(760,945,880,1000,1160,760);ctx.stroke();
  ctx.restore();
}

function routePoint(t){
  // cubic Bezier from lower left toward upper right
  var p0={x:80,y:1650},p1={x:300,y:1450},p2={x:520,y:1050},p3={x:930,y:840};
  var u=1-t;
  return {
    x:u*u*u*p0.x+3*u*u*t*p1.x+3*u*t*t*p2.x+t*t*t*p3.x,
    y:u*u*u*p0.y+3*u*u*t*p1.y+3*u*t*t*p2.y+t*t*t*p3.y
  };
}

function drawRoute(ctx,t){
  var b=B();
  var steps=90, upto=Math.max(2,Math.floor(steps*clamp(t,0,1)));
  ctx.save();ctx.lineCap="round";ctx.lineJoin="round";

  ctx.strokeStyle="rgba(108,255,179,"+(b.map.routeGlowAlpha||.20)+")";
  ctx.lineWidth=b.map.routeGlowWidth||24;
  ctx.beginPath();
  for(var i=0;i<upto;i++){
    var p=routePoint(i/(steps-1));
    if(i===0)ctx.moveTo(p.x,p.y);else ctx.lineTo(p.x,p.y);
  }
  ctx.stroke();

  ctx.strokeStyle=b.colors.routePrimary || b.colors.primary;
  ctx.lineWidth=b.map.routeWidth||12;
  ctx.beginPath();
  for(var j=0;j<upto;j++){
    var q=routePoint(j/(steps-1));
    if(j===0)ctx.moveTo(q.x,q.y);else ctx.lineTo(q.x,q.y);
  }
  ctx.stroke();
  ctx.restore();
}

function drawPin(ctx,x,y,scale){
  var b=B();scale=scale||1;
  ctx.save();ctx.translate(x,y);ctx.scale(scale,scale);
  ctx.fillStyle="rgba(108,255,179,.18)";ctx.beginPath();ctx.arc(0,0,58,0,Math.PI*2);ctx.fill();
  ctx.fillStyle=b.map.pinFill||b.colors.primary;ctx.beginPath();ctx.arc(0,0,34,0,Math.PI*2);ctx.fill();
  ctx.lineWidth=8;ctx.strokeStyle=b.map.pinStroke||b.colors.background;ctx.stroke();
  ctx.fillStyle=b.colors.background;ctx.beginPath();ctx.arc(0,0,10,0,Math.PI*2);ctx.fill();
  ctx.restore();
}

function drawPoi(ctx,x,y,pulse,label,selected){
  var b=B(), s=selected?1.18:1;
  ctx.save();ctx.translate(x,y);ctx.scale(s,s);
  ctx.fillStyle=selected?"rgba(108,255,179,.20)":"rgba(96,217,255,.18)";
  ctx.beginPath();ctx.arc(0,0,30+18*pulse,0,Math.PI*2);ctx.fill();
  ctx.fillStyle=selected?(b.map.selectedPoiFill||b.colors.primary):(b.map.poiFill||b.colors.secondary);
  ctx.beginPath();ctx.arc(0,0,18,0,Math.PI*2);ctx.fill();
  if(label){
    roundedRect(ctx,-70,34,140,52,20);
    ctx.fillStyle="rgba(13,31,41,.94)";ctx.fill();
    ctx.fillStyle=b.colors.text;ctx.font="800 20px "+b.typography.family;ctx.textAlign="center";
    ctx.fillText(label,0,68);
  }
  ctx.restore();
}

function drawDecisionCard(ctx,title,subtitle,alpha){
  var b=B();ctx.save();ctx.globalAlpha=alpha==null?1:alpha;
  roundedRect(ctx,110,300,860,210,b.geometry.cardRadius||24);
  ctx.fillStyle=b.cards && b.cards.background || "rgba(13,31,41,.94)";ctx.fill();
  ctx.lineWidth=2;ctx.strokeStyle=b.colors.border;ctx.stroke();
  ctx.fillStyle=b.colors.primary;ctx.font="800 24px "+b.typography.family;ctx.textAlign="left";
  ctx.fillText("DRIVE IQ",150,354);
  ctx.fillStyle=b.colors.text;ctx.font="900 46px "+b.typography.family;
  ctx.fillText(title,150,420);
  ctx.fillStyle=b.colors.mutedText;ctx.font="650 28px "+b.typography.family;
  ctx.fillText(subtitle,150,470);
  ctx.restore();
}

function drawCoffeeGeneratedScene(ctx,scene,local){
  var b=B();
  drawStylizedMapBase(ctx);

  var routeT=clamp(local*1.65,0,1);
  drawRoute(ctx,routeT);

  var pinT=clamp((local-.45)/.2,0,1);
  if(pinT>0) drawPin(ctx,930,840,.72+.28*pinT);

  var poiT=clamp((local-.56)/.25,0,1);
  if(poiT>0){
    var pulse=(Math.sin(local*Math.PI*8)+1)/2;
    drawPoi(ctx,700,955,pulse,"Coffee",false);
    if(poiT>.22)drawPoi(ctx,825,1060,pulse,"Cafe",false);
    if(poiT>.5)drawPoi(ctx,615,1110,pulse,"Local",false);
  }
  var selectT=clamp((local-.74)/.16,0,1);
  if(selectT>0){
    drawPoi(ctx,700,955,(Math.sin(local*Math.PI*8)+1)/2,"Coffee",true);
    drawDecisionCard(ctx,"Coffee • 0.4 mi","Useful stop near your destination",selectT);
  }

  drawBrand(ctx);
  drawTruthLabel(ctx);
  drawOverlay(ctx,scene,local);
}

function loadImage(url){
  return new Promise(function(resolve,reject){
    var img=new Image();img.onload=function(){resolve(img)};img.onerror=reject;img.src=url;
  });
}
function makeVideo(url){
  return new Promise(function(resolve,reject){
    var v=document.createElement("video");v.playsInline=true;v.muted=true;v.preload="auto";
    v.onloadedmetadata=function(){resolve(v)};v.onerror=function(){reject(new Error("Video could not load"))};
    v.src=url;try{v.load()}catch(e){}
  });
}
async function sourceForAsset(asset){
  var lib=global.DriveIQMomentumLibrary;
  var url=lib&&lib.urlFor?lib.urlFor(asset):"";
  if(!url)return null;
  if(asset.kind==="image")return {kind:"image",node:await loadImage(url),url:url};
  if(asset.kind==="video")return {kind:"video",node:await makeVideo(url),url:url};
  return null;
}
function drawSource(ctx,src){
  if(!src||!src.node){ctx.fillStyle=B().colors.background;ctx.fillRect(0,0,Engine.width,Engine.height);return}
  var n=src.node,sw=n.videoWidth||n.naturalWidth||n.width||1,sh=n.videoHeight||n.naturalHeight||n.height||1;
  var r=coverRect(sw,sh,Engine.width,Engine.height);
  try{ctx.drawImage(n,r.x,r.y,r.w,r.h)}catch(e){}
}
function drawLifestyleScene(ctx,scene,src,local){
  drawSource(ctx,src);
  // subtle camera push over still images / footage
  var b=B();
  ctx.save();
  var vign=ctx.createRadialGradient(540,900,300,540,900,1000);
  vign.addColorStop(0,"rgba(0,0,0,0)");vign.addColorStop(1,"rgba(0,0,0,.36)");
  ctx.fillStyle=vign;ctx.fillRect(0,0,Engine.width,Engine.height);
  ctx.restore();
  drawBrand(ctx);drawOverlay(ctx,scene,local);
}
function drawAppProofScene(ctx,scene,src,local){
  var b=B();
  ctx.fillStyle=b.colors.background;ctx.fillRect(0,0,Engine.width,Engine.height);
  if(src&&src.node){
    // phone-like proof frame
    roundedRect(ctx,185,205,710,1320,54);
    ctx.save();ctx.clip();
    var n=src.node, sw=n.videoWidth||n.naturalWidth||n.width||1, sh=n.videoHeight||n.naturalHeight||n.height||1;
    var r=coverRect(sw,sh,710,1320);
    try{ctx.drawImage(n,185+r.x,205+r.y,r.w,r.h)}catch(e){}
    ctx.restore();
    ctx.lineWidth=4;ctx.strokeStyle="rgba(255,255,255,.18)";
    roundedRect(ctx,185,205,710,1320,54);ctx.stroke();
  }else{
    drawDecisionCard(ctx,"Real app proof","Add a Drive IQ screenshot or screen recording",1);
  }
  drawBrand(ctx);drawOverlay(ctx,scene,local);
}

Engine.buildCoffeeRun = async function(opportunity,assets){
  opportunity=opportunity||{};assets=assets||[];
  var lifestyle=assets.filter(function(a){return a.kind==="video"||a.kind==="image"})[0]||null;
  var proof=assets.filter(function(a){
    var h=(String(a.feature||"")+" "+String(a.name||"")+" "+(a.tags||[]).join(" ")).toLowerCase();
    return /scan|arrival|coffee|local discovery/.test(h);
  })[0] || assets[1] || null;
  var payoff=assets[2] || lifestyle || null;

  return {
    recipe:"coffee",
    title:"Coffee Run",
    feature:"Scan Around",
    ctaHeadline:"Navigation should keep helping after you arrive.",
    ctaSub:"Find useful places around your destination with Drive IQ.",
    scenes:[
      {id:"human_open",type:"lifestyle",duration:3.2,overlay:"You made it. Now what?",subtext:"The next decision starts after the route ends.",asset:lifestyle},
      {id:"generated_map",type:"coffee_generated",duration:4.4,overlay:"Scan around your destination.",subtext:"Coffee, food, fuel, shopping and useful places nearby.",asset:null},
      {id:"proof",type:"app_proof",duration:3.0,overlay:"Real Drive IQ. Real product proof.",subtext:"Show the actual Scan Around experience.",asset:proof},
      {id:"payoff",type:"lifestyle",duration:2.8,overlay:"Drive there. Discover what’s around you.",subtext:"Navigation should do more than stop at the pin.",asset:payoff},
      {id:"cta",type:"end_card",duration:2.8,asset:null}
    ]
  };
};

Engine.buildStoryboard = async function(opportunity,assets){
  opportunity=opportunity||{};
  var feature=String(opportunity.feature||"").toLowerCase();
  if(feature.indexOf("scan around")>=0 || feature.indexOf("coffee")>=0){
    return Engine.buildCoffeeRun(opportunity,assets);
  }
  // Fallback: still use brand system for a generic branded sequence
  var hook=opportunity.hook||"Your GPS should do more than give directions.";
  var picks=(assets||[]).slice(0,3);while(picks.length<3)picks.push(null);
  return {
    title:opportunity.title||"Drive IQ in action",
    feature:opportunity.feature||"Drive IQ",
    ctaHeadline:B().cta.endCardHeadline,
    ctaSub:B().cta.endCardSubhead,
    scenes:[
      {id:"s1",type:"lifestyle",duration:3.2,overlay:hook,subtext:"Drive IQ",asset:picks[0]},
      {id:"s2",type:"coffee_generated",duration:4.2,overlay:opportunity.demoLine||"See the decision, not just the route.",subtext:opportunity.demoSub||"Drive IQ turns navigation into local intelligence.",asset:null},
      {id:"s3",type:"app_proof",duration:3.0,overlay:opportunity.payoffHeadline||"Real product proof.",subtext:opportunity.payoff||"Use the actual app when proof matters.",asset:picks[1]},
      {id:"s4",type:"end_card",duration:2.8,asset:null}
    ]
  };
};

Engine.render = async function(project,opts){
  opts=opts||{};
  if(!project||!project.scenes||!project.scenes.length)throw new Error("No storyboard to render");
  if(!HTMLCanvasElement.prototype.captureStream)throw new Error("Canvas video rendering is not supported on this device.");
  if(!global.MediaRecorder)throw new Error("MediaRecorder is not supported on this device.");

  var canvas=opts.canvas||document.createElement("canvas");
  canvas.width=Engine.width;canvas.height=Engine.height;
  var ctx=canvas.getContext("2d",{alpha:false});
  var stream=canvas.captureStream(Engine.fps);
  var mime=bestMime(),recorder;
  try{recorder=new MediaRecorder(stream,mime?{mimeType:mime,videoBitsPerSecond:9000000}:{videoBitsPerSecond:9000000})}
  catch(e){recorder=new MediaRecorder(stream);mime=recorder.mimeType||""}

  var chunks=[];
  recorder.ondataavailable=function(e){if(e.data&&e.data.size)chunks.push(e.data)};
  var done=new Promise(function(resolve,reject){
    recorder.onstop=function(){resolve(new Blob(chunks,{type:mime||"video/webm"}))};
    recorder.onerror=function(e){reject(e.error||new Error("Video render failed"))};
  });
  recorder.start(250);

  var total=project.scenes.reduce(function(s,x){return s+Number(x.duration||0)},0),elapsed=0;

  for(var si=0;si<project.scenes.length;si++){
    var scene=project.scenes[si],src=null;
    if(scene.asset){try{src=await sourceForAsset(scene.asset)}catch(e){}}
    if(src&&src.kind==="video"){try{src.node.currentTime=0;await src.node.play()}catch(e){}}

    var start=performance.now(),dur=(Number(scene.duration||3))*1000;
    while(performance.now()-start<dur){
      var local=(performance.now()-start)/dur;
      ctx.fillStyle=B().colors.background;ctx.fillRect(0,0,Engine.width,Engine.height);

      if(scene.type==="end_card"||scene.endCard)drawEndCard(ctx,project);
      else if(scene.type==="coffee_generated")drawCoffeeGeneratedScene(ctx,scene,local);
      else if(scene.type==="app_proof")drawAppProofScene(ctx,scene,src,local);
      else drawLifestyleScene(ctx,scene,src,local);

      if(opts.onProgress)opts.onProgress(clamp((elapsed+(local*scene.duration))/total,0,1),scene,si);
      await sleep(1000/Engine.fps);
    }
    if(src&&src.kind==="video"){try{src.node.pause()}catch(e){}}
    if(src&&src.url){try{URL.revokeObjectURL(src.url)}catch(e){}}
    elapsed+=Number(scene.duration||0);
  }

  recorder.stop();
  var blob=await done;
  if(opts.onProgress)opts.onProgress(1,null,project.scenes.length);
  return {blob:blob,mime:blob.type||mime,canvas:canvas,duration:total};
};

Engine.download=function(blob,name){
  var ext=(blob.type||"").indexOf("mp4")>=0?"mp4":"webm";
  var url=URL.createObjectURL(blob),a=document.createElement("a");
  a.href=url;a.download=(name||"drive-iq-momentum")+"."+ext;
  document.body.appendChild(a);a.click();a.remove();
  setTimeout(function(){URL.revokeObjectURL(url)},3000);
};

Engine.capabilities=function(){
  return {
    brandLoaded:!!global.DRIVE_IQ_BRAND,
    canvasCapture:!!HTMLCanvasElement.prototype.captureStream,
    mediaRecorder:!!global.MediaRecorder,
    preferredMime:bestMime(),
    coffeeRecipe:true
  };
};

global.DriveIQMomentumVideoEngine=Engine;
})(window);